<script setup lang="ts">
import { PopoverAnchor, PopoverContent, PopoverRoot, PopoverTrigger } from "reka-ui";
import { useDateField, DateTimeSegment } from "@formwerk/core";
import type { DateFieldProps } from "@formwerk/core";

const props = defineProps<DateFieldProps>();
const { controlProps, isTouched, labelProps, errorMessageProps, errorMessage, segments, direction, calendarProps, fieldValue, setValue } = useDateField({ ...props, locale: "fr-CA" });
const isOpened = ref(false);
watch(() => props.modelValue, () => isOpened.value = false);
</script>

<template>
  <div :dir="direction">
    <label v-bind="labelProps">
      {{ label }}
      <UiFieldRequired v-if="required" />
    </label>
    <PopoverRoot v-model:open="isOpened">
      <PopoverAnchor class="input-bordered relative flex items-center gap-2">
        <PopoverTrigger class="flex">
          <span class="i-lucide-calendar size-5" />
        </PopoverTrigger>
        <div v-bind="controlProps" class="flex-1">
          <DateTimeSegment v-for="(segment, i) in segments" :key="i" v-bind="segment" class="cursor-text" />
        </div>
        <button v-if="!required && fieldValue" type="button" class="absolute right-4 top-1/2 flex -translate-y-1/2" @click="setValue(null as unknown as Date)">
          <span class="i-lucide-x size-5" />
        </button>
      </PopoverAnchor>
      <PopoverContent class="popover-content rounded-lg bg-white p-2 shadow-lg" side="bottom" align="start">
        <UiCalendar v-bind="calendarProps" />
      </PopoverContent>
    </PopoverRoot>
    <div v-if="isTouched && errorMessage" v-bind="errorMessageProps" class="text-sm text-danger">
      {{ errorMessage }}
    </div>
  </div>
</template>

<style lang="postcss">
.popover-content {
  max-width: var(--reka-popover-trigger-width);
  transform-origin: var(--reka-popover-content-transform-origin);
}
</style>
